import $ from "jquery";
import Swiper from "swiper";
import { Mousewheel, Scrollbar } from "swiper/modules";

export default class NumberedCardCarousel {
  $el = $("section.numbered-card-carousel");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.setupCarousel();
  }

  setupCarousel() {
    Swiper.use([Mousewheel, Scrollbar]);

    const $scrollbar = this.$el.find(".swiper-scrollbar");

    new Swiper(this.$el.find(".swiper").get(0), {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      scrollbar: {
        el: $scrollbar.get(0),
        draggable: true,
        dragSize: 84,
        dragClass: ["swiper-scrollbar-drag", "bg-deep-purple"],
      },
      breakpoints: {
        500: {
          slidesPerView: 1.5,
        },
        600: {
          slidesPerView: 2,
        },
        1000: {
          slidesPerView: 2.5,
        },
        1200: {
          slidesPerView: 3,
        },
        1300: {
          slidesPerView: 4,
        },
        1600: {
          slidesPerView: 5,
        },
      },
    });
  }
}
